module.exports = __webpack_public_path__ + "966c9b4ef1d5433546674d6f75819fea.svg";